var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenewalExistingCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 147,
    viewBox: "0 0 180 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1866_5320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.3115 83.6235C88.4239 83.6235 107.16 64.9037 107.16 41.8118C107.16 18.7198 88.4239 0 65.3115 0C42.1991 0 23.4628 18.7198 23.4628 41.8118C23.4628 64.9037 42.1991 83.6235 65.3115 83.6235Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.892 156.713V163.474C128.892 165.973 126.971 168 124.61 168H4.28177C1.91313 168 0 165.973 0 163.474V109.689C0 98.0958 8.87826 88.7041 19.8353 88.7041H53.4352C53.8493 88.7041 54.222 88.9606 54.3959 89.3661L64.0526 109.929C64.2183 110.268 64.6738 110.268 64.8311 109.929L74.4962 89.3661C74.6618 88.9606 75.0428 88.7041 75.4569 88.7041H97.6857C94.0168 95.3569 91.9214 103.011 91.9214 111.153C91.9214 133.569 107.773 152.278 128.892 156.713Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.375 152.394C161.291 152.394 179.859 133.842 179.859 110.955C179.859 88.0587 161.291 69.507 138.375 69.507C123.749 69.507 110.887 77.07 103.508 88.5055C99.3255 94.968 96.8989 102.68 96.8989 110.955C96.8989 130.532 110.481 146.941 128.751 151.269C131.84 152.005 135.062 152.394 138.375 152.394ZM159.842 105.248C159.842 106.505 158.83 107.516 157.571 107.516H145.463C144.546 107.516 143.713 106.968 143.363 106.117C143.013 105.267 143.203 104.293 143.855 103.641L147.743 99.7471C141.821 93.9346 132.315 93.963 126.431 99.8416C120.519 105.749 120.519 115.323 126.431 121.229C132.343 127.136 141.925 127.136 147.838 121.229C149.02 120.048 150.94 120.048 152.123 121.229C153.305 122.411 153.305 124.329 152.123 125.511C143.846 133.781 130.432 133.781 122.155 125.511C113.878 117.241 113.878 103.839 122.155 95.5697C130.394 87.3283 143.742 87.2999 152.028 95.4752L155.963 91.5435C156.616 90.8914 157.59 90.7023 158.442 91.052C159.293 91.4017 159.842 92.2334 159.842 93.1502V105.248Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1866_5320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 168,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenewalExistingCustomer);
export default __webpack_public_path__ + "static/media/RenewalExistingCustomer.738f2b2b8e48c9676e5f62c91020a082.svg";
export { ForwardRef as ReactComponent };